export default "__VITE_ASSET__4spy15Y5__"